export const meta = {
  id: 'M03',
  slug: 'utilizar-diagnostico',
  title: 'Como utilizar o Diagnóstico do Mentorado',
  description: 'Use o Diagnóstico como referência para compreender competências, níveis e prioridades de desenvolvimento.',
  profile: 'mentor',
  category: 'diagnostico',
  type: 'task',
  status: 'published',
  order: 240,
  keywords: ['diagnóstico', 'mentorado', 'competências', 'níveis', 'prioridades', 'desenvolvimento'],
  previous: 'M02',
  next: 'M04',
  related: ['A02', 'A02.1', 'M04'],
  updatedAt: '2026-08-17',
  appVersion: 'v1'
}

# Como utilizar o Diagnóstico do Mentorado

O Diagnóstico é uma referência para compreender como o mentorado percebe seu momento atual em competências importantes para o desenvolvimento.

## O que observar

- competências priorizadas;
- nível ou situação identificada;
- descritores comportamentais associados;
- relação entre o Diagnóstico e o objetivo do mentorado;
- possíveis diferenças entre percepção, prática e Evidências posteriores.

## Como usar na Mentoria

<Steps>
  <Step title="Leia o resultado como ponto de partida">
    Use o Diagnóstico para formar hipóteses e perguntas, não para rotular a pessoa.
  </Step>
  <Step title="Conecte ao objetivo">
    Observe quais competências têm maior relação com aquilo que o mentorado quer alcançar.
  </Step>
  <Step title="Acompanhe mudanças ao longo do tempo">
    Compare o ponto inicial com metas, ações, Evidências e evolução observada nas Mentorias.
  </Step>
</Steps>

<Callout type="important">
  O Diagnóstico não é uma sentença permanente. Ele ajuda a orientar prioridades e a acompanhar evolução.
</Callout>

<Callout type="concept">
  Perguntas úteis: “Qual competência mais impacta seu objetivo agora?”, “O que mudou desde esse Diagnóstico?” e “Que Evidência mostraria avanço real?”.
</Callout>

<HelpImage alt="Diagnóstico do mentorado na visão do Mentor" pendingId="M03.1" />
